/*LIBRARY*/

const Image = (props) => {
  // Destructure alt from props
  const { src, alt } = props;

  const handle_click = (e) => {
    e.stopPropagation();
    if (props.blockProps && props.blockProps.on_image_click) {
      props.blockProps.on_image_click(src);
    }
  };

  if (!!src) {
    return (
      // Wrapped in a div to ensure elements stack properly within the block
      <div>
        <img
          src={src}
          alt={alt || "Content"}
          className="textImage"
          onClick={handle_click}
          style={{ cursor: "pointer" }}
        />
        {/* Only render this if alt exists */}
        {alt && (
          <div className="text_medium sub_color text_center margin_top">
            {alt}
          </div>
        )}
      </div>
    );
  }
  return null;
};

const Link = (props) => {
  if (!!props.link_url) {
    return (
      <a
        href={String(props.link_url)}
        rel="noopener noreferrer"
        target="_blank"
      >
        {props.link_text}
      </a>
    );
  }
  return null;
};

const YouTube = (props) => {
  if (!!props.youtube_url) {
    const get_youtube_id = (url) => {
      const reg_exp =
        /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(reg_exp);
      return match && match[2].length === 11 ? match[2] : null;
    };

    const video_id = get_youtube_id(props.youtube_url);

    if (video_id) {
      const embed_url = `https://www.youtube-nocookie.com/embed/${video_id}?rel=0&modestbranding=1`;

      return (
        <div
          className="youtube-container"
          style={{
            position: "relative",
            paddingBottom: "56.25%",
            height: 0,
            overflow: "hidden",
            maxWidth: "100%",
            marginBottom: "20px",
          }}
        >
          <iframe
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
            }}
            src={embed_url}
            title="YouTube video player"
            frameBorder="0"
            sandbox="allow-scripts allow-same-origin allow-presentation allow-popups"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            referrerPolicy="strict-origin-when-cross-origin"
            loading="lazy"
          />
        </div>
      );
    }
  }
  return null;
};

/* --- UPDATED MEDIA COMPONENT --- */
const Media = (props) => {
  const entity = props.contentState.getEntity(props.block.getEntityAt(0));
  const type = entity.getType();
  let media;

  if (type === "image") {
    // Extract alt from entity data
    const { src, alt } = entity.getData();
    // Pass alt to Image component
    media = <Image src={src} alt={alt} blockProps={props.blockProps} />;
  } else if (type === "link") {
    const { link_text, link_url } = entity.getData();
    media = <Link link_text={link_text} link_url={link_url} />;
  } else if (type === "youtube") {
    // LOGIC: Check if we should hide youtube
    if (props.blockProps && props.blockProps.hide_youtube) {
      // Option A: Completely Hide
      return null;

      // Option B: Show a placeholder text (Uncomment below if you prefer this)
      /* const { youtube_url } = entity.getData();
        return (
            <div style={{border: '1px solid #ddd', padding: '10px', marginBottom: '10px', fontSize: '12px', color: '#666', textAlign: 'center'}}>
                [Video skipped for PDF: {youtube_url}]
            </div>
        ); 
        */
    }

    const { youtube_url } = entity.getData();
    media = <YouTube youtube_url={youtube_url} />;
  }

  return media;
};

/* --- UPDATED EXPORT FUNCTION --- */
// Added a second argument `hide_youtube` with a default of false
export const get_media_block_renderer =
  (on_image_click, hide_youtube = false) =>
  (block) => {
    if (block.getType() === "atomic") {
      return {
        component: Media,
        editable: false,
        props: {
          on_image_click,
          hide_youtube, // Pass this prop down to Media
        },
      };
    }
    return null;
  };
